module.exports = __webpack_public_path__ + "img/1.d6dd7ed9.png";